@if (spinner) {
  <app-spinner></app-spinner>
}

<div class="inner-page-header">
  <div class="titles">
    <h3 class="title">المجموعات</h3>
  </div>
</div>

<div class="request-control mt-9" #goUp>
  <div class="right-side">
    <!-- Filter Component -->
    @if (filterData) {
      <app-filter
        [filterData]="filterData"
        [filterDataInit]="filterDataInit"
        [filterPage]="filterPage"
        (formValus)="filterFormValues($event)"
      >
      </app-filter>
    }

    <!-- Quick Search -->
    <quick-search
      [placeholder]="'البحث'"
      (searchResults)="quickSearch($any($event))"
    ></quick-search>
  </div>

  <div class="new-element">
    <button class="btn btn-add" (click)="addCohort()">
      <img src="assets/images/svg/add-icon.svg" alt="" />
      إضافة مجموعة 
    </button>
  </div>
</div>

@if (cohorts && cohorts.length > 0) {
  <div class="request-table">
    <div class="table-responsive">
      <table id="order-table" aria-label="" class="table table-striped">
        <thead>
          <tr>
            <th class="">ID</th>
            <th class="">اسم المجموعة</th>
            <th class="width-30">الوصف</th>
            <th class="">التخصصات</th>
            <th class="">الخبراء</th>
            <th class="">الحالة</th>
            <th class="">-</th>
          </tr>
        </thead>
        <tbody>
          @for (
            cohort of cohorts | paginate: config;
            track cohort.id; let index = $index
          ) {
            <tr
              class="table-row"
            >
              <td class="">{{ cohort.id }}</td>
              <td class="">{{ cohort.name }}</td>
              <td class="">{{ cohort.description }}</td>
              <td class="">{{ cohort.specializations_count }}</td>
              <td class="">{{ cohort.experts_count }}</td>
              <td class="">
                <app-switch-input
                  [label]="''"
                  [labelEn]="'is_active'"
                  [index]="cohort.id"
                  [labelDesc]="''"
                  [value]="cohort.is_active"
                  (valueChanged)="isActiveValueChanged($event, cohort.id, index)"
                >
                </app-switch-input>
              </td>
              <td class="">
                <button
                    class="btn btn-table-edit"
                    (click)="goToDetails(cohort.id)"
                  >
                    <img src="assets/images/svg/edit-icon.svg" alt="تعديل" />
                    تعديل
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <ayen-pagination
    (pageData)="pageChanged($event)"
    (pageSize)="pageSizeChanged($event)"
    [totalCount]="config.totalItems"
    [id]="'cohortPagination'"
    [itemsPerPage]="config.itemsPerPage"
    (pageChange)="pageChanged($event)"
    [currentPage]="config.currentPage"
  >
  </ayen-pagination>
} @else if (!spinner) {
  <div class="no-data-message d-flex justify-content-center">
    <p>لا توجد مجتمعات حالياً</p>
  </div>
}
